export default __webpack_public_path__ + "static/img_welfare_6-113be0c88b60d4dca08af02461b39c65.jpg";